export default "__VITE_ASSET__B5G5nf2___"